<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="负责部门" prop="chargePost">
<!--                <a-input v-model="queryParam.chargePost" placeholder="请输入" allow-clear/>-->
                <a-tree-select
                  v-model="queryParam.chargePost"
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="postOptions"
                  placeholder="请选择"
                  :replaceFields="{ children: 'children', title: 'postName', key: 'id', value: 'id' }"
                  tree-default-expand-all
                >
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="公司名称" prop="companyName">
                <a-input v-model="queryParam.companyName" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="驻场客服" prop="companyServiceName">
                <a-input v-model="queryParam.companyServiceName" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="财务人员" prop="companyFinanceName">
                <a-input v-model="queryParam.companyFinanceName" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:company:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:company:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <user-form
        ref="userForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1800 }"
      >
        <span slot="companyService" slot-scope="text, record">
            <a-tag v-if="record.companyServiceName" v-for="(companyService) in record.companyServiceName.split(',')" color="blue">
              {{companyService}}
            </a-tag>
          <div v-else>
            暂无
          </div>
        </span>
        <span slot="companyFinance" slot-scope="text, record">
          <a-tag v-if="record.companyFinanceName" v-for="(companyFinance) in record.companyFinanceName.split(',')" color="blue">
            {{companyFinance}}
          </a-tag>
          <div v-else>
            暂无
          </div>
        </span>
        <span slot="status" slot-scope="text, record">
          <div>
            <a-switch @click="updateStatus(record)" v-model="record.status == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
         <span slot="userCount" slot-scope="text, record">
           <a @click="$refs.userForm.handleQuery(record)">
             {{ record.userCount }}
           </a>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" />-->
<!--          <a @click="importTemplate(record.id)" >-->
<!--            <a-icon type="download" />下载工资模板-->
<!--          </a>-->
          <a-divider type="vertical" v-hasPermi="['user:company:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:company:edit']">
            <a-icon type="edit" />查看/编辑
          </a>
          <a-divider type="vertical" v-hasPermi="['user:company:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:company:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCompany, delCompany, updateCompany } from '@/api/user/company'
import CreateForm from './modules/CreateForm'
import UserForm from './modules/UserForm'
import { download } from '@/utils/request'
import { tableMixin } from '@/store/table-mixin'

const {queryPostList} = require("@/api/system/post");

export default {
  name: 'Company',
  components: {
    UserForm,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      postOptions: [],
      // 查询参数
      queryParam: {
        chargePost: null,
        companyName: null,
        province: null,
        companyServiceName: null,
        companyFinanceName: null,
        city: null,
        county: null,
        address: null,
        longitude: null,
        latitude: null,
        viewpager: null,
        logo: null,
        companyVideo: null,
        synopsis: null,
        tagIds: null,
        companyServiceIds: null,
        companyFinanceIds: null,
        status: null,
        cateName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '工厂ID',
          dataIndex: 'id',
          width: 160,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '公司名称',
          dataIndex: 'companyName',
          width: 200,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '驻场客服',
          dataIndex: 'companyService',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'companyService' }
        },
        {
          title: '财务人员',
          dataIndex: 'companyFinance',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'companyFinance' }
        },
        {
          title: '负责部门',
          dataIndex: 'chargePostName',
          width: 120,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '在招岗位数量',
          dataIndex: 'postCount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '在职员工数量',
          dataIndex: 'userCount',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'userCount' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.queryPostList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    queryPostList() {
      queryPostList().then(response => {
        this.postOptions = response.data
      })
    },
    /** 下载模板操作 */
    importTemplate (id) {
      const param = { companyId: id }
      debugger
      download('user/salary-head/importTemplate', {
        ...param
      }, `salary_template_${new Date().getTime()}.xlsx`).then(response => {
      })
    },
    updateStatus(record) {
      // 更改状态
      record.status = (record.status == 0) ? 1 : 0
      updateCompany(record).then(response => {
        this.$message.success(
          '修改成功',
          3
        )
        this.$emit('ok')
      }).finally(() => {
        this.getList()
      })
    },
    /** 查询公司列表 */
    getList () {
      this.loading = true
     pageCompany(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        companyName: undefined,
        province: undefined,
        city: undefined,
        county: undefined,
        address: undefined,
        longitude: undefined,
        latitude: undefined,
        viewpager: undefined,
        logo: undefined,
        companyVideo: undefined,
        synopsis: undefined,
        tagIds: undefined,
        companyServiceIds: undefined,
        companyFinanceIds: undefined,
        status: undefined,
        cateName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCompany(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/company/export', {
            ...that.queryParam
          }, `公司_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
